

import React, { useEffect } from 'react';

import { Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';
import { ContentWrapper } from './components/general_components/content_management/contentWrapper';
import { retrieveCompanyData } from './components/supplementary_components/companySettings';
import ProtectedRoute from './components/supplementary_components/protectedRoute';
import Login from './components/pages/authentication/Login';
import ForgotPassword  from './components/pages/authentication/ForgotPassword';
import ResetPassword from './components/pages/authentication/ResetPassword';

function LocationDefiner() {
	const location = useLocation().pathname;
	const currentCompany = retrieveCompanyData()
	if(!currentCompany){
		return <ContentWrapper currentCompany={currentCompany}/>
	}
	let category = location.slice(1, location.length);
	
	let itemIdentifier = '';
	if (category.indexOf('/') !== -1 && location.slice(category.indexOf('/')+2, location.length).length > 0){
		itemIdentifier = location.slice(category.indexOf('/')+2, location.length);
	}
	category = category.replace('/'+itemIdentifier, '');
	if(category === '')category="dashboard";
	
	return <ContentWrapper currentCompany={currentCompany} category={category} itemIdentifier={itemIdentifier} />
}
function App() {
    useEffect(() => {
        const handleStorageChange = (e) => {
            if (e.key === 'currentCompanyId' && e.newValue !== e.oldValue) {
                window.location.href = document.location.origin;
            }
        };
        window.addEventListener('storage', handleStorageChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);
	return (
        <Router>
            <Routes>
                {/* Route for the login page, does not require protection */}
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                {/* Protect all other routes only if security is enabled */}
                <Route path="/*" element={<ProtectedRoute element={<LocationDefiner />} securityEnabled={true} />} />
            </Routes>
        </Router>
	);
}


export default App;
